import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import CreateCredit from "../../../components/Modal/Admin/CreditManagement/CreateCredit";
import ViewCredit from "../../../components/Modal/Admin/CreditManagement/ViewCredit";
import EditCredit from "../../../components/Modal/Admin/CreditManagement/EditCredit";
import axiosInstance from "../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";



export default function CreditPgae() {
  const MySwal = withReactContent(Swal);
  const [credit, setCredit] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(3);
  const [filter, setFilter] = useState("");
  const [show, setShow] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [pagination, setPagination] = useState({});

  const storedPermissions = localStorage.getItem("userPermissions");
  const userDataString = localStorage.getItem("userData");
  let userTypeId = null;

  if (userDataString) {
    const userData = JSON.parse(userDataString);
    userTypeId = userData.user.user_type_id;

  } else {
    console.log("No user data found");
  }
  const permissions = storedPermissions ? JSON.parse(storedPermissions) : [];
  const hasPermission = (permission) => {
    return Array.isArray(permissions) && permissions.includes(permission);
  };


  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const orderResponse = await axiosInstance.get("/user/credit/fetch", {
          params: {
            page,
            filter,
          },
        });
        setCredit(orderResponse.data.data.credit.data);
        setPagination(orderResponse.data.data.credit);
      } catch (error) {
        console.error("Error fetching Credit:", error);
      }
    };

    fetchOrders();
  }, [page, filter, refreshKey]);

  const handleShow = () => setShow(true);
  const handleShowEdit = () => setShowEdit(true);
  const handleShowView = () => setShowView(true);

  const handleClose = () => {
    setShow(false);
    setShowEdit(false);
    setShowView(false);
    // setChangeImage(false);
  };
  const handleRefresh = () => {
    setRefreshKey((prevRefreshKey) => prevRefreshKey + 1);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
    setPage(1);
  };

  const handlePerPageChange = (event) => {
    setPerPage(event.target.value);
    setPage(1);
  };

  const toggleCreditApproval = async (id) => {
    try {
      const response = await axiosInstance.post(`/user/credit/approve_status/${id}`);
      toast.success(response.data.message);
      handleRefresh(); 
    } catch (error) {
      console.error("Error toggling credit status:", error);
      toast.error("Failed to update credit status.");
    }
  };

  const handleDeleteCredit = async (creditId) => {
    const result = await MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axiosInstance.post(
          `/user/credit/remove-credit/${creditId}`
        );
        handleRefresh();
        handleClose();
        toast.success("Credit removed successfully!");
      } catch (error) {
        toast("Error deleting credit:", error);
      }
    }
  };



  useEffect(() => { }, [refreshKey]);
  return (
    <>
      {/* <!-- start page title --> */}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0" style={{ color: "#c4281c" }}>
              Credit Management
            </h4>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="/app">Dashboard</Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#c4281c" }}
                >
                  Credit Management
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- end page title --> */}

      <div className="row" id="contactList">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header d-flex align-items-center border-0">
              <h5
                className="card-title mb-0 flex-grow-1"
                style={{ color: "#c4281b" }}
              >
                Credit Management
              </h5>
            </div>

            <div className="card-body border border-dashed border-end-0 border-start-0">
              <div className="d-flex justify-content-between">
                <div className="col-xl-4 col-md-6">
                  <div className="search-box">
                    <input
                      type="text"
                      className="form-control search"
                      placeholder="Search to product..."
                      value={filter}
                      onChange={handleFilterChange}
                    />
                    <i className="ri-search-line search-icon"></i>
                  </div>
                </div>
                {hasPermission("add_credit") && (

                  <div>
                    <button
                      className="vehicle-button btn "
                      style={{
                        backgroundColor: "#c4281b",
                        color: "#fff",
                        border: "none",
                      }}
                      onClick={handleShow}
                    >
                      <i className="mdi mdi-plus-circle-outline"></i> Add Credit
                    </button>
                  </div>
                )}

              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive table-card">
                <table
                  className="table align-middle table-nowrap table table-striped table-borderless table-hover"
                  id="customerTable"
                >
                  <thead className="table-light text-muted">
                    <tr>
                      <th scope="col">#</th>
                      <th> Company Name</th>
                      <th> City</th>
                      <th> State</th>
                      <th> Phone</th>
                      <th> Credit Level</th>
                      <th>date Added</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  {/* <!--end thead--> */}
                  <tbody className="list form-check-all">
                    {credit.map((credit, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>
                          {credit.company_name}{" "}
                        </td>
                        <td> {credit.city}</td>
                        <td> {credit.state}</td>
                        <td> {credit.phone}</td>
                        <td> Level {credit.credit_level}</td>
                        <td> {credit.date_added}</td>
                        <td className="status">
                          {credit.status === "approve" ? (
                            <span className="badge bg-success">Approved</span>
                          ) : credit.status === "pending" ? (
                            <span className="badge bg-warning">Pending</span>
                          ) : credit.status === "decline" ? (
                            <span className="badge bg-danger">Declined</span>
                          ) : (
                            <span className="badge bg-info">{credit.status}</span>
                          )}
                        </td>

                        <td>
                          <div className="dropdown">
                            <button
                              className="btn btn-icon btn-sm fs-16 text-muted dropdown"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="mdi mdi-apps"></i>
                            </button>
                            <ul className="dropdown-menu">
                              {/* <li>
                                <Link
                                  className="dropdown-item"
                                  onClick={() => handleShowView()}
                                >
                                  <i className="ri-eye-fill text-muted me-2 align-bottom"></i>
                                  View Customer
                                </Link>
                              </li> */}
                              {/* {hasPermission("add_credit") && (

                                <li>
                                  <Link
                                    className="dropdown-item"
                                    onClick={() => handleShowEdit()}
                                  >
                                    <i className="mdi mdi-pencil me-2 text-success"></i>{" "}
                                    Edit
                                  </Link>
                                </li>
                              )} */}
                              {hasPermission("delete_credit") && (

                                <li>
                                  {credit.status !=="approve" ? (

                                    <Link
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleDeleteCredit(credit.id)
                                      }
                                    >
                                      <i className="mdi mdi-trash-can-outline me-2 text-danger"></i>
                                      Delete Customer
                                    </Link>
                                  ) : null}
                                </li>

                              )}

                              {hasPermission("approved_credit") && (

                                <li>
                                  <Link
                                    className="dropdown-item"
                                    onClick={() => toggleCreditApproval(credit.id)}
                                  >
                                    <i className={`mdi ${credit.status === 'approve' ? 'mdi-check-circle' : 'mdi-cancel'} me-2`}></i>
                                    {credit.status === 'approve' ? 'decline' : 'approve'}
                                  </Link>
                                </li>
                              )}


                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="d-flex justify-content-end mt-5 mb-5">
                  <div className="pagination-wrap hstack gap-2">
                    <ul className="pagination listjs-pagination mb-0">
                      {(pagination.links || []).map((link, index) => {
                        const pageNumber = link.url
                          ? new URL(link.url).searchParams.get("page")
                          : null;

                        return (
                          <li
                            key={index}
                            className={`page-item ${link.active ? "active" : ""
                              }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                pageNumber &&
                                handlePageChange(Number(pageNumber))
                              }
                              dangerouslySetInnerHTML={{ __html: link.label }}
                            ></button>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <CreateCredit
          show={show}
          closeModal={handleClose}
          refreshPage={handleRefresh}
        />
        <EditCredit
          showEdit={showEdit}
          closeModal={handleClose}
          refreshPage={handleRefresh}
        />
        <ViewCredit
          showView={showView}
          closeModal={handleClose}
          refreshPage={handleRefresh}
        />
      </div>
    </>
  );
}
